import type { ReactNode } from 'react';
import React from 'react';
import styled from 'styled-components';

import { MQ } from '@rover/kibble/styles';

import type { AlignmentType } from '../layout.constants';
import { Alignment } from '../layout.constants';

export type Props = {
  children?: ReactNode;
  style?: any;
  vAlign: AlignmentType;
  hAlign: AlignmentType;
  vAlignBreakPoint?: AlignmentType;
  hAlignBreakPoint?: AlignmentType;
  vBreakPoint: MQ;
  role?: string | undefined;
  vBreakPointFlexDirection?: 'row' | 'column';
};

const ResponsiveWrapper = styled.div<Props>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: ${(props) => props.vAlign.toString()};
  justify-content: ${(props) => props.hAlign.toString()};

  ${(props) => props.vBreakPoint.toString()} {
    flex-direction: ${(props) => props.vBreakPointFlexDirection};
    justify-content: ${({ vAlignBreakPoint, vAlign }) => {
      if (vAlignBreakPoint) {
        return vAlignBreakPoint.toString();
      }
      return vAlign.toString();
    }};
    align-items: ${({ hAlignBreakPoint, hAlign }) => {
      if (hAlignBreakPoint) {
        return hAlignBreakPoint.toString();
      }
      return hAlign.toString();
    }};
  }
`;

const ResponsiveLayout = (props: Props): JSX.Element => (
  <ResponsiveWrapper {...props}>{props.children}</ResponsiveWrapper>
);

ResponsiveLayout.defaultProps = {
  children: '',
  style: {},
  vAlign: Alignment.START,
  hAlign: Alignment.START,
  vAlignBreakPoint: undefined,
  hAlignBreakPoint: undefined,
  vBreakPoint: MQ.XS,
  vBreakPointFlexDirection: 'column',
};

export default ResponsiveLayout;
